import { Component } from '@angular/core';

@Component({
  selector: 'app-security-icon',
  templateUrl: './security-icon.component.html',
  styleUrl: './security-icon.component.scss'
})
export class SecurityIconComponent {

}
